import client from "./axios";

// Le rotte basket-match del backend sono montate SENZA prefisso /admin
// (solo requireUser), come quelle del calcio: l'utente gestore è autenticato.
const baseUrl = "https://internal-api.getmoveapp.com/api/v1/basket-matches";

export type BasketSide = "team1" | "team2";
export type BasketWinner = "team1" | "team2" | "draw";

// Formati ammessi (giocatori per squadra).
export const BASKET_TEAM_SIZES = [1, 2, 3, 4, 5] as const;
export const DEFAULT_BASKET_TEAM_SIZE = 3;

export type BasketPlayerStats = {
  userId: string;
  matchesPlayed: number;
  matchesWon: number;
  matchesLost: number;
  matchesDrawn: number;
  points: number;
  reliabilityScore: number;
};

export type BasketMatchPlayer = {
  id: string;
  basketMatchId: string;
  userId?: string | null;
  guestName?: string | null;
  team: BasketSide;
  slot: number;
  points?: number;
  confirmed?: boolean;
  noShow?: boolean;
  user?: {
    id?: string;
    name?: string;
    familyName?: string;
    photo?: string | null;
    basketStats?: BasketPlayerStats | null;
  } | null;
};

export type BasketMatch = {
  id: string;
  bookingId: string;
  teamSize: number;
  teamName1?: string | null;
  teamName2?: string | null;
  pointsTeam1?: number | null;
  pointsTeam2?: number | null;
  winnerTeam?: BasketWinner | null;
  players?: BasketMatchPlayer[];
};

export const BasketMatchAPI = {
  getByBooking: (bookingId: string) =>
    client.get<{ result: BasketMatch | null }>(`${baseUrl}/get/${bookingId}`),
  createMatch: (body: { bookingId: string; teamSize?: number }) =>
    client.post<{ result: BasketMatch }>(`${baseUrl}/create`, body),
  addPlayer: (
    matchId: string,
    body: {
      userId?: string | null;
      guestName?: string | null;
      team: BasketSide;
      slot: number;
      addedById?: string | null;
    }
  ) =>
    client.post<{ result: BasketMatch }>(
      `${baseUrl}/${matchId}/add-player`,
      body
    ),
  removePlayer: (playerId: string) =>
    client.delete<{ result: string }>(`${baseUrl}/player/${playerId}`),
  updatePlayer: (
    playerId: string,
    body: { team?: BasketSide; slot?: number; guestName?: string | null }
  ) => client.put<{ result: string }>(`${baseUrl}/player/${playerId}`, body),
  // Nomi squadra e/o formato (teamSize 1..5).
  setMeta: (
    matchId: string,
    body: {
      teamName1?: string | null;
      teamName2?: string | null;
      teamSize?: number;
    }
  ) =>
    client.put<{ result: BasketMatch }>(`${baseUrl}/${matchId}/team-names`, body),
  setResult: (
    matchId: string,
    body: {
      pointsTeam1: number;
      pointsTeam2: number;
      winnerTeam?: BasketWinner;
      scorers?: { playerId: string; points: number }[];
    }
  ) => client.put<{ result: BasketMatch }>(`${baseUrl}/${matchId}/result`, body),
  confirmPresence: (body: { playerIds: string[]; confirmed: boolean }) =>
    client.put<{ result: BasketMatchPlayer[] }>(
      `${baseUrl}/confirm-presence`,
      body
    ),
  markNoShow: (playerId: string) =>
    client.put<{ result: BasketMatchPlayer }>(
      `${baseUrl}/player/${playerId}/no-show`,
      {}
    ),
};
